// Vendor libraries
import { CommonModule } from '@angular/common';
// Modules
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
// Components
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
// Pipes
import { GetCategoryScrollIdPipe } from './pipes/get-category-scroll-id.pipe';
import { GetCategoryTopScrollIdPipe } from './pipes/get-category-top-scroll-id.pipe';
import { GetMetricScrollIdPipe } from './pipes/get-metric-scroll-id.pipe';
import * as i0 from "@angular/core";
export class MetricSelectorModalModule {
}
MetricSelectorModalModule.ɵfac = function MetricSelectorModalModule_Factory(t) { return new (t || MetricSelectorModalModule)(); };
MetricSelectorModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MetricSelectorModalModule });
MetricSelectorModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [GetCategoryScrollIdPipe, GetCategoryTopScrollIdPipe, GetMetricScrollIdPipe], imports: [CommonModule, FeatureNeededModule, IconModule, IconSearchAutocompleteModule, ModalBaseModule] });
